<h1 mat-dialog-title>Hit Synchronisation - Einstellungen</h1>
<div mat-dialog-content>
    <mat-slide-toggle [(ngModel)]="active" style="margin: 12px 0" color="primary">
        Hit Synchronisation aktivieren
    </mat-slide-toggle>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-flat-button (click)="dialogRef.close()">Schließen</button>
    <button mat-flat-button color="accent" (click)="save()">Übernehmen</button>
</div>
